import { createSlice } from '@reduxjs/toolkit';
import getActionListaFunilByClienteId from 'src/actions/clientes/getActionListaFunilByClienteId';
import v1_actionGlobalFrontConfig from 'src/actions/global/v1_actionGlobalFrontConfig';
import v1_actionBuscarConfig from 'src/actions/v1/global/v1_actionBuscarConfig';
import v2_actionListaTagsChats from 'src/actions/v2/chats/v2_actionListaTagsChats';
// utils


const initialState = {
  isLoading: false,
  isStaff: null,
  stateSyncWpp:null,
  defcon:false,
  updateAvailable: false,
  optionsFunil:[],
  optionsTags:[],
  qrcode:null,
  loadingQrcodeWhatsapp:false,
  statusQrcodeRead:null,
  empresa: {
    openModal:false,
    loading:false
  },
  conversa: {
    openModal:false,
    loading:false
  },
  contato: {
    openModal:false,
    loading:false
  },
  negocio: {
    openModal:false,
    loading:false
  },
  grupoWhatsapp: {
    openModal:false,
    loading:false
  },
  modalAlerta: {
    open:false,
    mensagem:null,
    titulo:null
  },
  config: null,
  globalConfig: null,
  flag: {
    flag: 'red',
    status:false,
    msg: 'Identificamos uma instablilidade nas envio de links, estamos trabalhando para resolver o mais rápido possível'
  ,
}

};

const slice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },


    setIsOnlineUsers(state, action) {
      state.isOnlineUsers = action.payload;
    },

    setDefcon1(state, action) {
      state.defcon = action.payload;
    },

    setUpdateAvailable(state, action) {
      state.updateAvailable = action.payload;
    },

    setStateWhatsapp(state, action) {
      state.stateSyncWpp = action.payload;
    },

    setQrcode(state, action) {
      state.qrcode = action.payload;
    },
    setLoadingQrcodeWhatsapp(state, action) {
      state.loadingQrcodeWhatsapp = action.payload;
    },
    setStatusQrcode(state, action) {
      state.statusQrcodeRead = action.payload;
    },

    getListaOptionsFunilSuccess(state, action) {
      state.optionsFunil = action.payload;
    },
    getListaOptionsTagsSuccess(state, action) {
      state.optionsTags = action.payload;
    },
    getConfigSuccess(state, action) {
      state.config = action.payload;
    },
    getConfigGlobalSuccess(state, action) {
      state.globalConfig = action.payload;
      state.flag = action.payload.flag;
    },
    setEmpresa(state, action) {
      state.empresa = action.payload
    },
    setContato(state, action) {
      state.contato = action.payload
    },
    setConversa(state, action) {
      state.conversa = action.payload
    },
    setNegocio(state, action) {
      state.negocio = action.payload
    },
    setGrupoWhatsapp(state, action) {
      state.grupoWhatsapp = action.payload
    },

    setModalAlerta(state, action) {
      state.modalAlerta = action.payload
    },

    resetModalAlerta(state) {
      state.modalAlerta =  {
        open:false,
        mensagem:null,
        titulo:null
      }
    },

  }
});

// Reducer
export default slice.reducer;

// Actions
export const {setStateWhatsapp, resetModalAlerta, setModalAlerta, startLoading, setDefcon1, setUpdateAvailable, setQrcode, setLoadingQrcodeWhatsapp, setStatusQrcode, setEmpresa, setNegocio, setContato, setConversa, setGrupoWhatsapp } = slice.actions;




export function getListaOptionsFunil(clienteId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await getActionListaFunilByClienteId(clienteId);
      dispatch(slice.actions.getListaOptionsFunilSuccess(response.data.funis));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getListaOptionsTags(clienteId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      let querys = `?cliente_id=${clienteId}`
      const response = await v2_actionListaTagsChats(querys);
      dispatch(slice.actions.getListaOptionsTagsSuccess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}



export function getConfig() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await v1_actionBuscarConfig();
      dispatch(slice.actions.getConfigSuccess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}


export function getGlobalConfig(url) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await v1_actionGlobalFrontConfig(url);
      dispatch(slice.actions.getConfigGlobalSuccess(response.data));
    } catch (error) {
      console.error(error)
      dispatch(slice.actions.hasError(error));
    }
  };
}




